import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-action',
  exportAs: 'sidebarAction',
  host: {
    role: 'button',
    tabindex: '0',
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarAction {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-action',
      'flex cursor-pointer items-center justify-center rounded',
      'h-8 w-5 shrink-0 gap-x-2',

      // Sidebar icon
      '**:[sidebar-icon]:text-neutral-a9',
      'hover:[&_sidebar-icon]:text-neutral-12',

      // User classes
      this.userClass(),
    ),
  );
}
